import { render, staticRenderFns } from "./DeviceRegistrations.vue?vue&type=template&id=02596b09&"
import script from "./DeviceRegistrations.vue?vue&type=script&lang=js&"
export * from "./DeviceRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports